module.exports = __webpack_public_path__ + "static/media/intro-image.6e5aed3a.png";